import { render, staticRenderFns } from "./DisplayResultSendMessageGroup.vue?vue&type=template&id=274d48f2&scoped=true"
import script from "./DisplayResultSendMessageGroup.vue?vue&type=script&lang=js"
export * from "./DisplayResultSendMessageGroup.vue?vue&type=script&lang=js"
import style0 from "./DisplayResultSendMessageGroup.vue?vue&type=style&index=0&id=274d48f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274d48f2",
  null
  
)

export default component.exports